import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { jobDetailsLoaded } from '../../store/selectors/job-details.selectors';
import { JobState } from '../../store/state/job-details.state';
import { ExternalJobDisplayInputDto } from 'src/app/shared/models/external-job-display-input.dto';

@UntilDestroy()
@Component({
    selector: 'nova-locums-recruiter-add-details',
    templateUrl: './locums-recruiter-add-details.component.html',
    styleUrls: ['./locums-recruiter-add-details.component.scss']
})
export class LocumsRecruiterAdditionalDetailsComponent implements OnInit {
    @Input() displayConfigData: ExternalJobDisplayInputDto;

    description: string;

    constructor(private readonly store: Store<JobState>) {}

    ngOnInit(): void {
        this.store
            .select(jobDetailsLoaded)
            .pipe(
                filter((e) => e.success),
                untilDestroyed(this)
            )
            .subscribe((e) => {
                this.description = e.job.description;
            });
    }
}
